import { render, staticRenderFns } from "./GroupsNature.vue?vue&type=template&id=57da72aa&"
import script from "./GroupsNature.vue?vue&type=script&lang=js&"
export * from "./GroupsNature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports